import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { t } from '../../utils/textUtils';

const PageHeader = ({ title, icon, description }) => {
  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 3, 
        mb: 3, 
        backgroundColor: '#FFF8E1', 
        borderRadius: 2,
        border: '1px solid #F0C14B'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        {icon && (
          <Box sx={{ mr: 2, color: '#F0C14B' }}>
            {icon}
          </Box>
        )}
        <Typography variant="h5" component="h1" sx={{ fontWeight: 600, color: '#5D4037' }}>
          {t(title)}
        </Typography>
      </Box>
      {description && (
        <Typography variant="body1" color="text.secondary">
          {t(description)}
        </Typography>
      )}
    </Paper>
  );
};

export default PageHeader;